
import {throwError as observableThrowError, Subject } from 'rxjs';

import {finalize, take, delay, retryWhen, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/Rx';
import { LoginService } from '../../login/shared/login.service';
import { DataService } from '../../user-detail.service';
import { environment } from './../../../environments/environment';


@Injectable()
export class AlertApplicationService {
    id: number;
    redirectUrl: string;
    private exceptionSubject = new Subject<any>();
    private unOrLockSubject = new Subject<any>();
    private onBulkLock = new Subject<any>();
    private refreshSubject = new Subject<any>();
    

    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
        private dataService: DataService
    ) { 
        let user = this.dataService.getStaffInformation;
        this.id = user._id;
     }

    getAnnualAlertList(date: string, leader_id: number) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/alert_application_list/alert_count?date=' + date + '&leader_id=' + leader_id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getApplicationList(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        let params = new HttpParams();
        if (data.date) { params = params.append('date',data.date); }
        if (data.limit) { params = params.append('limit',data.limit); }
        if (data.page) { params = params.append('page',data.page); }
        if (data.employment_category) { params = params.append('employment_category',data.employment_category); }
        if (data.branch_office) { params = params.append('branch_office',data.branch_office); }
        if (data.application_status) { params = params.append('application_status',data.application_status); }
        if (data.complete_modified) { params = params.append('complete_modified',data.complete_modified); }
        if (data.leader_id) { params = params.append('leader_id',data.leader_id); }
        if (data.train_delay) { params = params.append('train_delay',data.train_delay); }
        if (data.search_name) { params = params.append('search_name',data.search_name); }
        if (data.alert_date) { params = params.append('alert_date',data.alert_date); }
        if (data.isExempted) { params = params.append('isExempted',data.isExempted); }
        if (data.department) { params = params.append('department',data.department); }

        const options = { 
            headers: headers,
            params: params 
        };

        return this.http.get(environment.SERVER_URL + '/alert_application_list/application_list', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }
    getAdminComment(id: any, date: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/attendance_application/admin_comment?staff_id=' + id +'&date=' + date, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }
    
    dailyTimeSchedule(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/daily_time_schedule/detail?staffId=' + data.staff_id + '&date=' + data.date, options).pipe(
            map(this.extractData),
            retryWhen(errors => errors.pipe(delay(1000),take(2),)),
            catchError(this.handleError),);
    }

    excludeStaff(alertId: string, status: boolean, app_id: string, reason: string) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/alert/exempted?_id=' + alertId + '&isExempted=' + status + '&app_id=' + app_id + '&reason=' + reason, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.exceptionSubject.next();
                        }),);
    }

    lockApplication(data) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/attendance_application/lock?_id=' + data.id + '&date_for=' + data.timestamp_date + '&staff_id=' + data.staff_id, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.unOrLockSubject.next();
                        }),);
    }
    
    /**
     * Get application detail of a date regardless if approved or not
     * @staff_id
     * @app_target_date 
     */
    getApplicationByDate(data) {
        let params = new HttpParams();
        params = params.set('staff_id', data.staff_id);
        params = params.set('app_target_date', data.app_target_date);

        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers, params:params };

        // return this.http.get(environment.SERVER_URL + '/attendance_application/detail_all?staff_id='+data.id+'&app_target_date='+data.date, options)
        return this.http.get(environment.SERVER_URL + '/attendance_application/detail_all', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getApplicationIsExempted(data) {
        let params = new HttpParams();
        params = params.set('staff_id', data.staff_id);
        params = params.set('date', data.app_target_date);

        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers, params: params };

        // return this.http.get(environment.SERVER_URL + '/attendance_application/detail_all?staff_id='+data.id+'&app_target_date='+data.date, options)
        return this.http.get(environment.SERVER_URL + '/attendance_application/is_exempted', options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }
    unlockApplication(data) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/attendance_application/unlock?_id=' + data.id + '&date_for=' + data.timestamp_date + '&staff_id=' + data.staff_id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.unOrLockSubject.next();
                        }),);
    }

    sendAlertMail(struct: any) {
        struct.token = this.authenticate.getToken();
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/alert_application_list/send_email', struct, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.unOrLockSubject.next();
                        }),);
    }

    getApplicationDetails(data: any) {
        let params = new HttpParams();
        
        params = params.set('_id', data.appId);
        params = params.set('app_target_date', data.targetDate);
        params = params.set('staff_id', data.staffId);

        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers, params: params };

        return this.http.get(environment.SERVER_URL + '/attendance_application/detail_by_id', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getTimestampById(data) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/attendance_application/pre_form_data?staff_id='+data.id+'&date='+data.date, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    approveApplication(data: any) {
        data.token = this.authenticate.getToken();
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/attendance_application/approve', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    bulkLock(data: any) {
        data.token = this.authenticate.getToken();
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/attendance_application/multi_lock_unlock', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.onBulkLock.next();
                        }),);
    }

    bulkException(data: any){
        data.token = this.authenticate.getToken();
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/alert_application_list/bulk_exception', data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),
            finalize(() => {
                // this.onBulkLock.next();
            }),);
    }

    cancelApproval(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/attendance_application/cancel_approved?staff_id='+data.staff_id+'&app_target_date='+data.targetDate, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    checkTimestampBackup(data: any) {

        let headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        let params = new HttpParams();
        params = params.append('date', data.date);
        params = params.append('staff_id', data.staff_id);
        const options = { headers: headers, params: params };

        return this.http.get<any>(environment.SERVER_URL + '/timestamp_backup/detail', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getApplySysById(data: any) {
        let params = new HttpParams();
        params = params.set('staffId', data.id);
        params = params.set('date', data.date);

        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers, params: params };

        return this.http.get(environment.APPLY_URL + '/general-data-public/get-all-by-date', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    onException() {
        return this.exceptionSubject.asObservable();
    }

    onLockOrUnlock() {
        return this.unOrLockSubject.asObservable();
    }

    onBulkLockObserve() {
        return this.onBulkLock.asObservable();
    }

    onRefresh() {
        return this.refreshSubject.asObservable();
    }

    private extractData(res: any) {
        let body = res;
        return body.data || {};
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
        const body = error || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}
